import React from 'react';
import { STATUS_STEPS, SPECIAL_STATUSES } from '../../constants/status';

export default function StatusTimeline({ currentStatus }) {
  const special = SPECIAL_STATUSES[currentStatus];

  if (special) {
    return (
      <div className={`rounded-2xl p-5 border ${
        special.color === 'red' ? 'border-red-200 bg-red-50' : 'border-amber-200 bg-amber-50'
      }`}>
        <div className="flex items-start gap-3">
          <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${
            special.color === 'red' ? 'bg-red-100' : 'bg-amber-100'
          }`}>
            <svg className={`w-5 h-5 ${special.color === 'red' ? 'text-red-600' : 'text-amber-600'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M12 2a10 10 0 100 20A10 10 0 0012 2z" />
            </svg>
          </div>
          <div>
            <p className={`font-semibold text-sm ${special.color === 'red' ? 'text-red-800' : 'text-amber-800'}`}>
              {special.title}
            </p>
            <p className={`text-xs mt-1 leading-relaxed ${special.color === 'red' ? 'text-red-600' : 'text-amber-600'}`}>
              {special.msg}
            </p>
          </div>
        </div>
      </div>
    );
  }

  const currentIdx = STATUS_STEPS.findIndex((s) => s.key === currentStatus);

  return (
    <div className="space-y-0">
      {STATUS_STEPS.map((step, idx) => {
        const isDone = idx < currentIdx;
        const isActive = idx === currentIdx;
        const isLast = idx === STATUS_STEPS.length - 1;

        return (
          <div key={step.key} className="flex gap-3.5">
            <div className="flex flex-col items-center">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-all duration-300 ${
                isDone
                  ? 'bg-emerald-500 shadow-sm shadow-emerald-200'
                  : isActive
                  ? 'bg-brand-500 ring-4 ring-brand-100 shadow-sm shadow-brand-200'
                  : 'bg-slate-200'
              }`}>
                {isDone ? (
                  <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                ) : isActive ? (
                  <div className="w-2.5 h-2.5 bg-white rounded-full" />
                ) : (
                  <div className="w-2 h-2 bg-slate-300 rounded-full" />
                )}
              </div>
              {!isLast && (
                <div className={`w-0.5 flex-1 my-1 transition-colors duration-300 ${isDone ? 'bg-emerald-300' : 'bg-slate-200'}`} style={{ minHeight: 24 }} />
              )}
            </div>
            <div className={`pb-5 ${isLast ? 'pb-0' : ''}`}>
              <p className={`text-sm font-medium leading-8 ${
                isDone ? 'text-emerald-700' : isActive ? 'text-brand-700 font-semibold' : 'text-slate-400'
              }`}>
                {step.label}
              </p>
              {isActive && (
                <p className="text-xs text-brand-500 -mt-1 font-medium">Current stage</p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
